import React, { useState } from "react";
import { useAppContext } from "../../context";
import Loader from "../Loader";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import BrancheAddress from "../BrancheAddress";

export default function CurrencBody({ data }: { data: any[] }) {
    const { currentRateData, tab } = useAppContext();
    const [openRow, setOpenRow] = useState<number | null>(null);

    const groupedRates = React.useMemo(() => {

        
        if (tab === 2) {
            return currentRateData;
        }

        if (!currentRateData) return [];

        const map: Record<string, any> = {};

        currentRateData.forEach((row: any) => {
            const key = row.code;
            
            if (!map[key]) {
                map[key] = {
                    ...row,
                    branches: [],
                };
            }
            
            map[key].branches.push({
                descrip: row.descrip,
                BuyRate: row.buy,
                SellRate: row.sell,
                TargetISO: row.targetCurrency,
                SourceISO: row.sourceCurrency,
            });
        });

        return Object.values(map);
    }, [currentRateData, tab]);


    if (!groupedRates) return <Loader />;

    return (
        <>
            {groupedRates?.map((row: any, idx: number) => {
                const isOpen = openRow === idx;


                return (
                    <Box key={idx}>
                        {/* ===== MAIN ROW ===== */}
                        <Box
                            sx={{
                                background: { xs: "#FFFFFF", md: "transparent" },
                                borderRadius: { xs: "16px", md: "0px" },
                                p: { xs: 2.5, md: 2 },
                                mb: { xs: 2, md: 0 },
                                boxShadow: { xs: "0px 4px 20px rgba(0,0,0,0.05)", md: "none" },
                                display: "grid",
                                gridTemplateColumns: {
                                    xs: "1fr",
                                    md: "1fr 2fr 1fr 1fr 60px",
                                },
                                borderBottom: { xs: "none", md: "1px solid #f0f0f0" },
                                gap: { xs: 2, md: 0 },
                                alignItems: "center",
                            }}
                        >
                            {/* CODE / AMOUNT / NAME */}
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                <Box
                                    sx={{
                                        backgroundColor: "#FFE6E2",
                                        color: "#FF4D3B",
                                        fontWeight: 700,
                                        fontSize: "13px",
                                        borderRadius: "8px",
                                        width: "70px",
                                        height: "36px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    {row.code}
                                </Box>

                                <Typography sx={{ fontWeight: 600 }}>
                                    {row.amount}
                                </Typography>

                                <Typography sx={{ color: "#27384E", opacity: 0.8 }}>
                                    {row.name}
                                </Typography>
                            </Box>

                            {/* MOBILE BUY / SELL */}
                            <Box
                                sx={{
                                    display: { xs: "grid", md: "none" },
                                    gridTemplateColumns: row.nbgRate ? "repeat(3, 1fr)" : "repeat(2, 1fr)",
                                    textAlign: "center",
                                    gap: 2,
                                }}
                            >
                                {row.nbgRate &&
                                    <Box>
                                        <Typography fontSize={13} color="#7A8FA6">
                                            ოფიციალური კურსი
                                        </Typography>
                                        <Typography fontWeight={700}>{row?.nbgRate}</Typography>
                                    </Box>
                                }
                                <Box>
                                    <Typography fontSize={13} color="#7A8FA6">
                                        ყიდვა
                                    </Typography>
                                    <Typography fontWeight={700}>{row.buy}</Typography>
                                </Box>
                                <Box>
                                    <Typography fontSize={13} color="#7A8FA6">
                                        გაყიდვა
                                    </Typography>
                                    <Typography fontWeight={700}>{row.sell}</Typography>
                                </Box>
                            </Box>

                            {/* DESKTOP BUY / SELL */}
                            {row.nbgRate && <Typography
                                sx={{ display: { xs: "none", md: "block" }, textAlign: "center", fontWeight: 600 }}
                            >
                                {row.nbgRate}
                            </Typography>}

                            <Typography
                                sx={{ display: { xs: "none", md: "block" }, textAlign: "center", fontWeight: 600 }}
                            >
                                {row.buy}
                            </Typography>

                            <Typography
                                sx={{ display: { xs: "none", md: "block" }, textAlign: "center", fontWeight: 600 }}
                            >
                                {row.sell}
                            </Typography>

                            {/* COLLAPSE BUTTON */}
                            {row.descrip && <IconButton
                                onClick={() => setOpenRow(isOpen ? null : idx)}
                                sx={{
                                    backgroundColor: "transparent",
                                    "&:hover": {
                                        backgroundColor: "transparent",
                                    },
                                    "&:active": {
                                        backgroundColor: "transparent",
                                    },
                                    "&.Mui-focusVisible": {
                                        backgroundColor: "transparent",
                                    },
                                }}
                            >
                                {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>}

                        </Box>

                        {/* ===== COLLAPSE CONTENT ===== */}
                        {row.descrip && <BrancheAddress branches={row.branches} isOpen={isOpen} />}
                    </Box>
                );
            })}
        </>
    );
}
